<template>
    <div class="news-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>探物资讯</h1>
                <p class="English">Tanworth Information</p>
            </div>
        </div>
        <div class="container">
            <ul class="type-list">
                <li v-for="(item,index) in typeList" :key="index" class="vertical-middle select-point" :class="{active:item.themeLabelId == askData.labelId}" @click="changeType(item)">
                    {{item.themeLabelName}}
                </li>
            </ul>
            <div class="news-list">
                <newsItem v-for="(item,index) in listData" :key="index" :item = "item" class="item" @click.native="goDetail(item)"></newsItem>
            </div>
            <div class="pages-wrap">
                <span v-for="(item,index) in pageData.pages" :key="index" class="item select-point" :class="{active:item == askData.pageNumber}" @click="changePage(item)">{{item}}</span>
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import newsItem from '@components/newsItem';
    export default {
		data() {
			return {
                askData:{
                    pageNumber:1,
                    pageSize:15,
                    labelId:0,
                    orderBy:1
                },
                pageData:{
                    pages:0
                },
                typeList:[],
                listData:[],
			}
        },
        components: {
            newsItem
		},
        created(){
            network(CONFIG.themeLabels).then(res => {
               this.typeList = res.details.list;
            });
            this.getData();
        },
        methods:{
            initData(){
                this.askData.pageNumber = 1;
                this.getData();
            },
            getData(){
                network(CONFIG.themesByLabel,this.askData).then(res => {
                    let listData = [];
                    res.data.map(item => {
                        listData.push({
                            id:item.themeId,
                            image:item.themeImage,
                            title:item.themeTitle,
                            time:this.formatTime(item.datetime)
                        })
                    });
                    this.listData = listData;
                    this.pageData = res.page;
                });
            },
            changeType(item){
                if(this.askData.labelId == item.themeLabelId) return
                this.askData.labelId = item.themeLabelId;
                this.initData();
            },
            changePage(item){
                if(this.askData.pageNumber == item) return
                this.askData.pageNumber = item;
                this.getData();
            },
            goDetail(item){
               this.$router.push("/newsDetail?id="+item.id)
            },
        }
    }
</script>

<style lang="scss">
    .news-page {
        min-height: 1000px;
        .public-banner{
            background-image:url('https://resource.tanwuapp.com/FnpGVYhVjgT0acEfWwBwoVB0gceB') ;
        }
        .news-list{
            .item{
                margin-bottom: 40px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/news.vue